/**
A class for managing back in stock notifications

Note -- uses Back In Stock Shopify App

*/

export class BackInStockNotice {
  constructor() {
    this.allVariantsIds = [];
    this.variant = {
      id: false,
      title: false,
      productId: false,
    };

    this.modal = document.querySelector("[data-bis-modal]");
    this.overlay = this.modal.querySelector("[modal-overlay]");
    this.container = this.modal.querySelector("[modal-inner]");
    this.closeIcon = this.modal.querySelector("[modal-close]");
    this.variantName = document.getElementById("bis_variant");

    this.formResponse = document.getElementById("formResponse");
    this.form = document.getElementById("bis_form");
    this.submitLabel = document.getElementById("modal-btn-label");
    this.submitSpinner = document.getElementById("modal-btn-spinner");

    this.overlay.addEventListener("click", () => {
      this._close();
    });

    this.closeIcon.addEventListener("click", () => {
      this._close();
    });
  }

  /**

  Sets the active variant ID, title, and product ID for BIS notification and adds a click event listener to the button element with the given variant ID if it has not been added yet.

  @param {number} variantId - The ID of the variant.
  @param {string} variantTitle - The title of the variant.
  @param {number} productId - The ID of the product.
  */
  _createBtn(variantId, variantTitle, productId) {
    //set active variable for BIS notification
    this.variant.id = variantId;
    this.variant.title = variantTitle;
    this.variant.productId = productId;

    //add eventListernere to button if one has not been added yet
    if (!this.allVariantsIds.includes(variantId)) {
      const triggerBtn = document.querySelector(`[data-bis-id="${variantId}"]`);
      triggerBtn.addEventListener("click", this._handleClick);
      this.allVariantsIds.push(variantId);
    }
  }

  _handleClick = () => {
    this._mount();
  };

  /**
    Handles form submission event by creating BIS notification for given variant ID and email input.
    @param {Event} e - Form submission event object.
  */
  _handleSubmit = (e) => {
    e.preventDefault();

    this._enableLoadingState(true);

    const formData = new FormData(e.target);
    const formProps = Object.fromEntries(formData);

    const email = formProps.emailInput;
    const emailList = formProps.hasOwnProperty("emailList");
    const variantId = this.variant.id;
    const productId = this.variant.productId;

    BIS.create(email, variantId, productId, {
      accepts_marketing: emailList,
    }).then((data) => {
      setTimeout(() => {
        formResponse.innerHTML =
          data.status == "OK" ? data.message : data.errors.base;
        formResponse.style.color = data.status == "OK" ? "inherit" : "red";
        this._enableLoadingState(false);
      }, 500);
    });
  };

  /**
    Enables/disables the loading state of the BackInStockNotice form.
    @param {boolean} status - Whether to enable the loading state or not.
  */
  _enableLoadingState(status) {
    if (status) {
      $("#submitBtn").attr("disabled", true);
      $(this.submitLabel).hide();
      $(this.submitSpinner).show();
    } else {
      $("#submitBtn").attr("disabled", false);
      $(this.submitLabel).show();
      $(this.submitSpinner).hide();
    }
  }

  _mount() {
    this.variantName.innerHTML = `${this.variant.title}`;
    this.form.addEventListener("submit", this._handleSubmit);
    this._display();
  }

  /**
    Displays a modal and locks the screen
  */
  _display() {
    //lock screen
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
    $("body").bind("touchmove", function (e) {
      e.preventDefault();
    });

    //display modal
    $(this.modal).addClass("active");

    this.overlay.style.opacity = ".20";

    setTimeout(() => {
      this.container.style.opacity = "1";
      this.container.style.top = "0px";
    }, 100);
  }

  /**
    Closes the modal and resets form and values
  */
  _close() {
    //unlock screen
    document.body.style.height = "auto";
    document.body.style.overflow = "auto";
    $("body").bind("touchmove", function (e) {
      e.preventDefault();
    });

    //reset form + values
    this.form.reset();
    this.formResponse.innerHTML = "";

    //close modal
    $(this.modal).removeClass("active");

    this.overlay.style.opacity = "0";
    this.container.style.opacity = "0";
    this.container.style.top = "16px";
  }
}
